import type { SearchParamsWithPreset } from 'typesense/lib/Typesense/Documents';

import type { PetitionHitData, PetitionSearchParams, SortByEnum } from './types';

export const HITS_PER_PAGE = 8;
const MAX_FACET_VALUES = 30;

function buildFilterBy(params: PetitionSearchParams): string {
	const filters: string[] = [];

	if (params.topics.length > 0) {
		const topicValues = params.topics.map((t) => `\`${t}\``).join(',');
		filters.push(`tags:=[${topicValues}]`);
	}

	if (params.status === 'victory') {
		filters.push('status:=victory');
	}

	if (params.status === 'trending') {
		filters.push('weekly_signature_count:>=10');
	}

	if (params.locationCities.length > 0) {
		const cityValues = params.locationCities.map((c) => `\`${c}\``).join(',');
		filters.push(`location.city_state:=[${cityValues}]`);
	}

	if (params.locationCountries.length > 0) {
		const countryValues = params.locationCountries.map((c) => `\`${c}\``).join(',');
		filters.push(`location.country_code:=[${countryValues}]`);
	}

	return filters.join(' && ');
}

function buildSortBy(sortBy: SortByEnum | undefined): string | undefined {
	switch (sortBy) {
		case 'most_signatures':
			return 'total_signature_count:desc';
		case 'least_signatures':
			return 'total_signature_count:asc';
		case 'newest':
			return 'created_at:desc';
		default:
			return undefined;
	}
}

export function buildTypesenseSearchParams(
	params: PetitionSearchParams,
	preset: string,
): SearchParamsWithPreset<PetitionHitData, string> {
	const filterBy = buildFilterBy(params);
	const sortBy = buildSortBy(params.sortBy);

	return {
		q: params.query || '*',
		preset,
		facet_by: 'tags,status,location.city_state,location.country_code',
		...(filterBy ? { filter_by: filterBy } : {}),
		...(sortBy ? { sort_by: sortBy } : {}),
		page: params.page + 1,
		per_page: HITS_PER_PAGE,
		max_facet_values: MAX_FACET_VALUES,
	};
}
